import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonDropdownSearchComponent } from '../common-component-dropdown-search/common-component-dropdown-search.component';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { CustomerMasterApiService } from '../CommonController/customer-master-service';
import { DispatchDeviceApiService } from '../CommonController/dispatch-device-api-service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-dispatch-device-page',
  templateUrl: './dispatch-device-page.component.html',
  styleUrls: ['./dispatch-device-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    CommonSearchComponent,
    CommonPaginationComponent,
    CommonDropdownSearchComponent,
    DatePipe,
  ],
})
export class DispatchDevicePageComponent implements OnInit {
  // Pagination settings
  pageSize = 10; // Number of items per currentPage
  currentPage = 1; // Current currentPage
  totalItems = 0; // Total number of items (for pagination purposes)
  searchText = ''; // Search text
  dispatchDeviceList = [];

  dispatchForm: FormGroup;

  userPermission = [];
  loggedId = '';

  listOfCustomers = [];
  filteredListOfCustomers = [];
  customerId = '';

  dispatchDeviceView = false;
  dispatchDeviceUpdate = false;
  dispatchDeviceCreate = false;
  dispatchDeviceDelete = false;

  constructor(
    public dispatchDeviceApiService: DispatchDeviceApiService,
    public commonApiService: CommonApiService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    public customerMasterApiService: CustomerMasterApiService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setDispatchDeviceListForm();
    this.getCustomersList();
    this.fetchDispatchList();
  }

  checkPermission() {
    this.loggedId = sessionStorage.getItem('loggedInUserId');
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermissions'));
    this.userPermission.forEach((element) => {
      if (element.pageName === 'Dispatch Device' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'Dispatch Device' && element.view === true) {
        this.dispatchDeviceView = true;
      }
      if (element.pageName === 'Dispatch Device' && element.update === true) {
        this.dispatchDeviceUpdate = true;
      }
      if (element.pageName === 'Dispatch Device' && element.create === true) {
        this.dispatchDeviceCreate = true;
      }
      if (element.pageName === 'Dispatch Device' && element.delete === true) {
        this.dispatchDeviceDelete = true;
      }
    });
  }

  setDispatchDeviceListForm() {
    this.dispatchForm = this.fb.group({
      dispatchDeviceListSearch: new FormControl(''),
    });
  }

  fetchDispatchList() {
    this.spinner.show();
    this.dispatchDeviceApiService
      .getDispatchBatchList(
        this.currentPage,
        this.pageSize,
        this.customerId,
        this.searchText
      )
      .subscribe({
        next: (res) => {
          this.dispatchDeviceList = res.data;
          this.totalItems = res.totalItems;
          this.commonApiService.openSnackbar(res.message);
          this.spinner.hide();
        },
        error: (error) => {
          this.dispatchDeviceList = []; // Clear the list
          this.totalItems = 0; // Reset the total count
          this.currentPage = 1;
          this.commonApiService.openSnackbar(
            error.error.message || 'An error occurred while fetching data.'
          );
          this.spinner.hide();
        },
      });
  }

  getCustomersList() {
    this.customerMasterApiService.getAllCustomer(1, 100000, '').subscribe({
      next: (res) => {
        this.listOfCustomers = res.data;
        this.filteredListOfCustomers = this.listOfCustomers.slice();
        this.filteredListOfCustomers.unshift({
          id: '',
          customerName: 'All',
          createdAt: '2024-12-17 16:39:38',
        });
        this.filteredListOfCustomers = this.filteredListOfCustomers.map(
          (item) => {
            return {
              key: item.customerName,
              value: item.id,
            };
          }
        );
      },
      error: (ERROR: HttpErrorResponse) => {
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  prepopulation(dispatchBatchId) {
    this.router.navigate(['dispatch-device-add-page', dispatchBatchId]);
  }

  delete(dispatchBatchId) {
    const userId = this.loggedId;
    if (confirm('Are you Sure?')) {
      this.spinner.show();
      this.dispatchDeviceApiService
        .deleteDispatchBatchData(dispatchBatchId)
        .subscribe((res) => {
          if (res.status) {
            this.commonApiService.openSnackbar(res.message);
          } else {
            this.commonApiService.openSnackbar(res.message);
          }
          this.fetchDispatchList(); // Refresh list after deletion
          this.spinner.hide();
        });
    }
  }

  AddNew() {
    this.router.navigate(['dispatch-device-add-page']);
  }

  AddNewExcel() {
    this.router.navigate(['dispatch-device']);
  }

  onPageChange(event) {
    this.spinner.show();
    this.currentPage = event;
    this.searchText = this.dispatchForm.get('dispatchDeviceListSearch').value;
    this.fetchDispatchList();
  }

  onSearchInputChange(event) {
    this.currentPage = 1;
    this.searchText = event;
    this.fetchDispatchList();
  }

  onSizeChange(newSize): void {
    this.pageSize = newSize; // Update the pageSize
    this.currentPage = 1; // Reset to the first currentPage
    this.fetchDispatchList();
  }

  onCustomerSelected(event): void {
    this.customerId = event;
    this.currentPage = 1;
    this.fetchDispatchList();
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
